import React from 'react';
import { TableCell, Checkbox } from '@material-ui/core';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import clsx from 'clsx';
import { TableSelection as TableSelectionBase } from '@devexpress/dx-react-grid';
import useStyles from './TableSelectAllCell.styles';
import useIsSomeActionExecuting from '../../../../lowLevel/FormAction/useIsSomeActionExecuting';

const TableSelectAllCell = ({
  allSelected,
  someSelected,
  disabled,
  onToggle,
  className,
  rowSpan,
  forwardedRef,
  ...restProps
}: TableSelectionBase.HeaderCellProps & any) => {
  const classes = useStyles();
  const { isSomeActionExecuting } = useIsSomeActionExecuting();
  const isDisabled = disabled || isSomeActionExecuting;

  const handleClick = (e: React.MouseEvent<HTMLTableCellElement>) => {
    e.stopPropagation();

    // Инвертируем логику: если что-то выбрано (allSelected или someSelected),
    // то снимаем выбор, иначе выбираем все
    if (allSelected || someSelected) {
      // Снимаем выбор со всех элементов
      onToggle(false);
    } else {
      // Выбираем все элементы
      onToggle(true);
    }
  };

  return (
    <TableCell
      padding="checkbox"
      className={clsx(className, {
        [classes.cell]: true,
        [classes.pointer]: !isDisabled,
        [classes.alignWithRowSpan]: rowSpan > 1,
        [classes.disabled]: isDisabled,
      })}
      rowSpan={rowSpan}
      ref={forwardedRef}
      onClick={isDisabled ? undefined : handleClick}
      {...restProps}
    >
      <Checkbox
        checked={allSelected}
        className={classes.checkbox}
        indeterminate={someSelected}
        indeterminateIcon={
          <IndeterminateCheckBoxIcon
            color={isDisabled ? 'disabled' : 'primary'}
          />
        }
        disabled={isDisabled}
        color="primary"
      />
    </TableCell>
  );
};

export default TableSelectAllCell;
